import axios from "axios";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

import { putStorage } from "hooks/useStorage";

const PartnersAPI = {
    getAllPartners: async () => {
        try {
            const { data: response } = await axios.get("/v2/partners");
            putStorage("partners", response || []);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ko50dnhc1i"));
        }
    },

    createPartner: async (data: any) => {
        try {
            const { data: response } = await axios.post("/v2/partners", { ...data });
            await PartnersAPI.getAllPartners();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("q0q5kh2jc3"));
        }
    },

    updatePartner: async (data: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = await axios.put("/v2/partners", { ...data });
            await PartnersAPI.getAllPartners();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("vmmgbc45mlk"));
        }
    },

    deletePartner: async (id: string) => {
        try {
            const { data: response } = await axios.delete(`/v2/partners/${id}`);
            await PartnersAPI.getAllPartners();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("873rga3gye5"));
        }
    }
};

export default PartnersAPI;
